import { ComponentProps } from 'react';
// @ts-expect-error TS(7016): Could not find a declaration file for module 'reac... Remove this comment to see the full error message
import ReactSelectBase from 'react-select';

import { Box } from 'components/Box';

export function ReactSelect({
  label,
  ...props
}: ComponentProps<typeof ReactSelectBase>) {
  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    <label>
      {label && <Box display="none">{label}</Box>}
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <ReactSelectBase {...props} />
    </label>
  );
}
